import React from 'react';
import { Button } from './ui/button';
import { Shield, Network, TrendingUp } from 'lucide-react';

export const PartnershipSection = () => {
  const benefits = [
    {
      icon: <Network size={32} />,
      title: 'Scalable Infrastructure',
      description: 'Modern processing designed to grow alongside your business'
    },
    {
      icon: <Shield size={32} />,
      title: 'Secure Transactions',
      description: 'Built around PCI DSS aligned security and compliance practices'
    },
    {
      icon: <TrendingUp size={32} />,
      title: 'Backend Settlement',
      description: 'Clean financial settlement and reconciliation workflows'
    }
  ];

  return (
    <section id="partnership" className="section-padding bg-gradient-to-br from-[#0A1128] via-[#1E3A8A] to-[#0F172A] text-white relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden opacity-20">
        <img
          src="https://images.unsplash.com/photo-1683322499436-f4383dd59f5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHx0ZWNobm9sb2d5JTIwaW5mcmFzdHJ1Y3R1cmV8ZW58MHx8fHwxNzc5MTI4MDE0fDA&ixlib=rb-4.1.0&q=85"
          alt="Infrastructure"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Partnership <span className="text-[#10B981]">Opportunities</span>
            </h2>
            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              Syrveo is open to collaborating with payment institutions, infrastructure providers, and ecosystem partners as we scale our merchant network across Europe and the Middle East.
            </p>

            <div className="space-y-6 mb-8">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-[#10B981]/20 rounded-lg flex items-center justify-center text-[#10B981]">
                    {benefit.icon}
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2">{benefit.title}</h3>
                    <p className="text-gray-300">{benefit.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <Button
              className="bg-[#10B981] hover:bg-[#059669] text-white px-8 py-6 rounded-lg font-semibold text-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            >
              Become a Partner
            </Button>
          </div>

          {/* Right Content */}
          <div className="relative hidden lg:block">
            <div className="relative z-10">
              <img
                src="https://images.unsplash.com/photo-1690378820474-b468b8ee64d3"
                alt="European IT team collaborating in modern office"
                className="rounded-2xl shadow-2xl w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnershipSection;
